var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "11", height: "11", viewBox: "0 0 11 11", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M31.7832972,107.601479 L37.6923882,107.601479 L37.6923882,108.783297 L31.7832972,108.783297 L31.7832972,114.692388 L30.6014791,114.692388 L30.6014791,108.783297 L24.6923882,108.783297 L24.6923882,107.601479 L30.6014791,107.601479 L30.6014791,101.692388 L31.7832972,101.692388 L31.7832972,107.601479 Z", transform: "rotate(45 142.524 25.308)", fill: "#FFFFFF", fillRule: "evenodd" })
  );
});